<template>
	<div class="cms-content">
		<div class="segmented-control-wrapper">
			<div class="container-title">
				<h2 class="heading-2">{{ $t('userManagement') }}</h2>
				<ja-button
					v-if="showCreate && (isSuperAdmin || isUSAAdmin)"
					name="save"
					class="small"
					@click.native.prevent="onCreateNew"
					>{{ $t('createNew') }}</ja-button
				>
			</div>
			<!-- Table simulation Template -->
			<ja-user-management-table
				v-if="showCreate && dataTableUserManagement"
				:data="dataTableUserManagement"
				@editRow="handleEditRow"
				@deleteRow="handleDeleteRow"
			></ja-user-management-table>
			<!-- Create new Template -->
			<ja-create-new-user-management
				v-if="!showCreate"
				:data-edit="dataEdit"
				@saveUserManagement="handleSaveSimulation"
				@cancel="handleCancel"
			></ja-create-new-user-management>
		</div>
	</div>
</template>
<script>
import Button from '@/components/ui/Button';
import UserManagementTable from './UserManagementTable.vue';
import CreateNewUserManagement from './CreateNewUserManagement.vue';
import UserManagementService from '@/services/cms/UserManagementService';
import AdminFacility from '@/mixins/AdminFacility';

export default {
	components: {
		jaUserManagementTable: UserManagementTable,
		jaCreateNewUserManagement: CreateNewUserManagement,
		jaButton: Button
	},
	mixins: [AdminFacility],
	props: {},
	data() {
		return {
			showCreate: true,
			dataTableUserManagement: null,
			dataEdit: null
		};
	},
	computed: {
		isReturnOption() {
			return this.$store.state.isReturnOption;
		}
	},
	watch: {
		selectedFacility() {
			this.$store.commit('setLoading', true);
			this.showCreate = true;
			this.getUserManagement();
		},
		isReturnOption(newValue) {
			if (newValue === true) {
				this.showCreate = true;
			} else {
				this.showCreate = false;
			}
		}
	},
	mounted() {
		this.$store.commit('setLoading', true);
		this.getUserManagement();
	},
	methods: {
		async getUserManagement() {
			const data = await UserManagementService.getAll(this.selectedFacilityId);
			this.dataTableUserManagement = data;
			this.$store.commit('setLoading', false);
		},
		async onCreateNew() {
			const data = await UserManagementService.getById(this.selectedFacilityId);
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleEditRow(rowData) {
			const data = await UserManagementService.getById(
				this.selectedFacilityId,
				rowData.user_ID
			);
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleSaveSimulation(userManagement) {
			this.$store.commit('setLoading', true);
			await UserManagementService.update(userManagement);
			await this.getUserManagement();
			this.showCreate = true;
		},
		async handleDeleteRow(rowData) {
			this.$store.commit('setLoading', true);
			await UserManagementService.deleteById(rowData.user_ID);
			await this.getUserManagement();
			this.showCreate = true;
		},
		async handleCancel() {
			this.$store.commit('setLoading', true);
			await this.getUserManagement();
			this.showCreate = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.container-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.cms-content {
	margin: auto;
	max-width: 1000px;
	margin-top: 32px;
	margin-bottom: 32px;
}
</style>
